import { ParticipantTile, TrackReferenceOrPlaceholder, useEnsureTrackRef } from '@livekit/components-react';
import { Track } from 'livekit-client';
import NameCardOverlay from './NameCardOverlay';

const ParticipantTileWithFallback = ({
  trackRef: trackRefProp,
  safeFramingScale,
}: {
  trackRef?: TrackReferenceOrPlaceholder;
  safeFramingScale?: number | null;
}) => {
  const trackRef = useEnsureTrackRef(trackRefProp);
  const nameCard = <NameCardOverlay participantMetadata={trackRef.participant.metadata} />;

  const hasSafeFraming = safeFramingScale !== null && safeFramingScale !== undefined;

  // Apply safe framing scale via CSS variable if provided
  const style = hasSafeFraming
    ? ({ '--safe-framing-scale': String(safeFramingScale) } as React.CSSProperties)
    : undefined;

  const className = hasSafeFraming ? 'lk-participant-tile safe-framing' : 'lk-participant-tile';

  if (trackRef.publication?.kind !== Track.Kind.Video) {
    return (
      <div
        data-lk-audio-muted={true}
        data-lk-video-muted={true}
        data-lk-speaking={false}
        data-lk-local-participant={trackRef.participant.isLocal}
        data-lk-source={Track.Source.Camera}
        data-lk-facing-mode={'undefined'}
        className={className}
        style={style}
      >
        <video
          className="lk-participant-media-video"
          data-lk-local-participant="false"
          data-lk-source="camera"
          data-lk-orientation="landscape"
          autoPlay={true}
          playsInline={true}
        ></video>
        <div className="lk-participant-placeholder"></div>
        {nameCard}
      </div>
    );
  }

  // Wrap ParticipantTile with safe-framing class if needed
  if (hasSafeFraming) {
    return (
      <div className="safe-framing-wrapper" style={style}>
        <ParticipantTile trackRef={trackRef} className="safe-framing" />
        {nameCard}
      </div>
    );
  }

  return (
    <div className="lk-participant-tile-wrapper">
      <ParticipantTile trackRef={trackRef} />
      {nameCard}
    </div>
  );
};

export default ParticipantTileWithFallback;
